import { Box, Typography } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { semanticColors } from "./utils/colors";
import { typography } from "./utils/typography";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import { useVideoState } from "./state";

export default function Disconnected() {
  // @ts-ignore
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation<{ isPatient?: boolean }>();
  const { setEndRoom, setIsOwner } = useVideoState();
  const isPatient = location.state?.isPatient === true;

  const handleReturn = () => {
    setEndRoom(false);
    setIsOwner(false);
    history.push("/video");
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor={semanticColors.surface.containerLow}
      px={2}
    >
      <Box
        bgcolor={semanticColors.surface.canvas}
        borderRadius="16px"
        boxShadow="0px 4px 24px rgba(30, 39, 79, 0.08)"
        overflow="hidden"
        maxWidth={480}
        width="100%"
      >
        <Box sx={{ background: semanticColors.gradient.surface }} height={8} />

        <Box p={5} textAlign="center">
          <Box
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            width={72}
            height={72}
            borderRadius="50%"
            sx={{ background: semanticColors.highlight.low }}
            mb={3}
          >
            <VideoCallIcon
              sx={{ fontSize: 36, color: semanticColors.action.primary }}
            />
          </Box>

          <Typography
            sx={{
              ...typography.heading.m,
              color: semanticColors.text.primary,
              mb: 1
            }}
          >
            {t("disconnected.message")}
          </Typography>

          {isPatient ? (
            <Typography
              sx={{
                ...typography.body.l,
                color: semanticColors.text.secondary,
                mt: 1
              }}
            >
              {t("disconnected.patientSubtitle")}
            </Typography>
          ) : (
            <Box display="flex" flexDirection="column" gap={2} mt={2}>
              <Box
                component="button"
                onClick={handleReturn}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: semanticColors.gradient.surface,
                  borderRadius: "40px",
                  height: "48px",
                  width: "100%",
                  border: "none",
                  cursor: "pointer",
                  px: "24px"
                }}
              >
                <Typography
                  sx={{
                    ...typography.body.lBold,
                    color: semanticColors.text.inverse
                  }}
                >
                  Voltar às Videoconsultas
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
